import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const UnverifiedEmailBanner: React.FC = () => {
  const { user, resendVerification } = useAuth();
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [message, setMessage] = useState<string>('');

  if (!user || user.email_verified === undefined || user.email_verified) return null;

  const onResend = async () => {
    setStatus('sending');
    try {
      const msg = await resendVerification();
      setMessage(msg);
      setStatus('sent');
    } catch (err: any) {
      setMessage(
        err?.response?.data?.detail?.message ||
          err?.response?.data?.detail ||
          'Could not resend right now.'
      );
      setStatus('error');
    }
  };

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: 'rgba(245, 158, 11, 0.10)',
        border: '1px solid rgba(245, 158, 11, 0.45)',
        color: '#fbbf24',
        padding: '10px 14px',
        borderRadius: '6px',
        fontSize: '13px',
        margin: '0 0 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        flexWrap: 'wrap',
      }}
    >
      <span>
        Verify your email ({user.email}) to unlock alerts and the daily digest.
        {status === 'sent' && message && (
          <span style={{ color: '#22c55e', marginLeft: '8px' }}>{message}</span>
        )}
        {status === 'error' && message && (
          <span style={{ color: '#f44336', marginLeft: '8px' }}>{message}</span>
        )}
      </span>
      <button
        type="button"
        onClick={onResend}
        disabled={status === 'sending' || status === 'sent'}
        style={{
          background: 'transparent',
          border: '1px solid rgba(245, 158, 11, 0.6)',
          color: '#fbbf24',
          padding: '6px 12px',
          borderRadius: '4px',
          fontSize: '12px',
          cursor:
            status === 'sending' || status === 'sent' ? 'not-allowed' : 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        {status === 'sending'
          ? 'Sending...'
          : status === 'sent'
            ? 'Sent ✓'
            : 'Resend email'}
      </button>
    </div>
  );
};

export default UnverifiedEmailBanner;
